import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { map, Observable } from "rxjs";
import { ApplyContentRemovalSanction, ApplyPermanentSuspensionSanction, ApplyTemporarySuspensionSanction, ApplyWarningSanction, IReportCategory, IReports } from "../dto/reports";
import { SanctionType } from "../pages/reports/reports.interface";

@Injectable({ providedIn: 'root' })
export class ReportsService {
    private http = inject(HttpClient);
    private BASE_URL = environment.api.url;

    getReports(): Observable<IReports[]> {
        return this.http.get<IReports[]>(`${this.BASE_URL}/report`);
    }

    getReportCategories(): Observable<IReportCategory[]> {
        return this.http.get<IReportCategory[]>(`${this.BASE_URL}/report/categories`);
    }

    checkCooldown(sanctionedUserId: string): Observable<SanctionType | null> {
        return this.http.get<{ lastSanctionType: SanctionType | null }>(
            `${this.BASE_URL}/report/cooldown/${sanctionedUserId}`
        ).pipe(
            map(response => response.lastSanctionType)
        );
    }

    applyWarningSanction(payload: ApplyWarningSanction): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/report/warning`, payload);
    }

    applyContentRemovalSanction(payload: ApplyContentRemovalSanction): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/report/content-removal`, payload);
    }

    applyTemporarySuspensionSanction(payload: ApplyTemporarySuspensionSanction): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/report/temporary-suspension`, payload);
    }

    applyPermanentSuspensionSanction(payload: ApplyPermanentSuspensionSanction): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/report/permanent-ban`, payload);
    }
}